/* globals addQueryParam, getNextDays, updateEventBind, dateMidpoint, getTimeRange */
/* The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

(function () {
	'use strict';

	angular.module('widgets.buyer')
		.controller('buyerChartController', buyerChartController);

	buyerChartController.$inject = ['$scope', '$location', '$timeout', '$state', '$experiments', 'config', 'hostUrl',
		'getJsonData', 'title', 'type', 'currencyFormatService', 'numberFormatService', 'integerFormatService',
		'percentageFormatService', 'dashboardFilterInitializationService', '$rootScope', 'pageTimingService',
		'weeklyLogItemService', 'leanFilterService', 'drilldownFunctionsService', 'shortageCriticalityLevelService', 'storeService',
		'buyerStdCurrentShortagesService', 'buyerWidgetsService'];

	function buyerChartController($scope, $location, $timeout, $state, $experiments, config, hostUrl, getJsonData, title, type, currencyFormatService,
			numberFormatService, integerFormatService, percentageFormatService, dashboardFilterInitializationService,
			$rootScope, pageTimingService, weeklyLogItemService, leanFilterService, drilldownFunctionsService,
			shortageCriticalityLevelService, storeService, buyerStdCurrentShortagesService, buyerWidgetsService) {
		if (!$scope.$parent.content.defaultDrillDownUrl) {
			$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
		}
		var iconMap = buyerWidgetsService.getTaskIcons();
		var iconTip = buyerWidgetsService.getTaskTooltips();
		var itemCtrlDivEl = angular.element(document.getElementById('itemCtrlDiv'));
		$scope.openModal = itemCtrlDivEl.scope().openModal;
		$scope.addTask = function(row, location) {
			$rootScope.$broadcast('createProcurementTask', {
				factoryNdx: row.ldfNdx,
				itemNdx: row.itemNdx,
				itemCodeDisplay: row.itemCodeDisplay,
				fullItemCode: row.itemCode,
				location: location,
				row: row
			});
		};
		$scope.show_table = false;
		$scope.collapse = false;
		$scope.expand = true;
		$scope.slideshowView = $rootScope.slideshowView;

		//all the functions rely on the type from the API call to determine which chart data is needed
		$scope.currency = $rootScope.currencySymbol;
		$scope.chartId = type;
		$scope.chartTitle = title;
		$scope.bgNum; // just a declaration
		$scope.formattedBgNum; // just a declaration
		$scope.addnlBgNumUnits = '';
		$scope.loadingTable = false; //this is used to add an individual loading spinner for the table ajax call
		var chartProps = chartProperties[$scope.chartId]; //load the chart properties based on the chart type
		var reactDrilldownUrl = $scope.$parent.content.reactDrilldownUrl;
		var reactDrilldownExperiment = $scope.$parent.content.reactDrilldownExperiment;
		$scope.drilldownDefaultTabs = chartProps.drilldownDefaultTabs;
		$scope.location = chartProps.location;
		$scope.widgetName = chartProps.widgetName;
		$scope.bgHide = !!chartProps.bgHide;
		$scope.hasTable = !!chartProps.tableUrl;
		$scope.addnlLabelText = chartProps.addnlLabelText;
		$scope.bgNumClass = chartProps.bgNumClass;
		$scope.bgNumParentDivClass = chartProps.bgNumParentDivClass;
		$scope.bottomData = chartProps.bottomData;
		$scope.expandedTitle = chartProps.expandedTitle;
		$scope.expandedTitleAlt = chartProps.expandedTitleAlt;
		$scope.dateRange = getNextDays(-7);
		$scope.settings = {};
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.updateKpiOnGroupLegendClick = chartProps.updateKpiOnGroupLegendClick;
		$scope.useReactDrilldown = reactDrilldownExperiment ? $experiments.isEnabled(reactDrilldownExperiment) : !!reactDrilldownUrl;
		$scope.excludeBlanketOrdersFilter = $experiments.isEnabled('supply-and-demand-blanket-checkbox');
		$scope.excludeNoImpactSupplyFilter = $experiments.isEnabled('no-impact-supply');
		$scope.allFeatures = $experiments.getAll();
		var eventName = 'event:' + type + 'Ctrl:getChart';
		if (eventName === 'event:clearToBuildPercentageCtrl:getChart' ||
			eventName === 'event:clearToCommitPercentageCtrl:getChart'){
			var factoryListFromFilter = leanFilterService.getFactoryList().split(',');
			var currentCustomerSites = Object.keys(globalConfig.user.authFacts)
							.filter(function(site) {
								return globalConfig.user.authFacts[site].customerNdx === globalConfig.customer.id;
							});
			var clearToBuildV1Enabled = currentCustomerSites.filter(
				function(site) {
					return globalConfig.user.authFacts[site]['settings'] &&
									globalConfig.user.authFacts[site]['settings']['GenerateClearToBuild'] === '1';
				}).includes(factoryListFromFilter[0]);

			var clearToBuildV2Enabled = currentCustomerSites.filter(
				function(site) {
					return globalConfig.user.authFacts[site]['settings'] &&
									globalConfig.user.authFacts[site]['settings']['GenerateClearToBuildFlattenedReqs'] === '1';
				}).includes(factoryListFromFilter[0]);

			var ctbVariant = '';
			if(clearToBuildV1Enabled){
				ctbVariant = '/single-level';
			}
			if (clearToBuildV2Enabled){
				ctbVariant = '/multi-level';
			}
			reactDrilldownUrl += ctbVariant;
		}
		$scope.reactReportDrilldownUrl = function (filters, sorters, useReportFilters) {
			return reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, useReportFilters, sorters || []);
		};

		for (var settingName in config.settings) {
			if (config.settings.hasOwnProperty(settingName)) {
				$scope.settings[settingName] = config.settings[settingName];
			}
		}

		$scope.isShortages = (eventName === 'event:criticalShortagesCtrl:getChart' || eventName === 'event:criticalShortagesManufacturedCtrl:getChart');
		$scope.isPoPlacements = (eventName === 'event:poPlacementCtrl:getChart');

		if (($scope.isShortages || $scope.isPoPlacements) && !$scope.settings.breakdown) {
			$scope.showCriticalityConfig = true;
			$scope.settings.breakdown = 'None';
		}

		if (chartProps.defaultTab) {
			$scope.settings.activeTab = chartProps.defaultTab;
		}

		// controls in the widget title bar are in different scope
		var widgetContainerScope = $scope.$parent.$parent;
		widgetContainerScope.showViewReport = false;

		if (config.settings === undefined && $scope.chartId !== 'indirectSpend') {
			if (!$scope.isShortages && !$scope.isPoPlacements) {
				$scope.showEditConfig = true;
				widgetContainerScope.hidePencil = true;

				if ($scope.config.type == 'daysOfInventory') {
					$scope.settings.doiCalculationItemType = 'Purchased Items';
					$scope.settings.doiCalculation = 'Backwards';
					$scope.settings.doiCalculationTurnsOrDays = 'Days';
					$scope.$parent.$parent.definition.config.title = 'Days Of Inventory';
				}

				if ($scope.config.type == 'componentAvailabilityPercent') {
					$scope.settings.breakdown = 'Current';
					$scope.settings.itemType = 'Purchased,Manufactured';
				}
			}
		}

		if ($scope.$parent.model.isNew && $scope.isPoPlacements) {
			$scope.showEditConfig = true;
			widgetContainerScope.hidePencil = true;
			$scope.$parent.model.isNew = false;
		}

		if ($scope.chartId === 'indirectSpend') {
			widgetContainerScope.hidePencil = true;
		}

		widgetContainerScope.editWidgetSettings = function () {
			$scope.showEditConfig = true;
			widgetContainerScope.hidePencil = true;
			if ($scope.config.type === 'daysOfInventory') {
				$scope.$parent.$parent.definition.config.title = 'Days Of Inventory';
			}
		};

		$scope.getDrillDownUrlString = function () {
			var url = $scope.$parent.content.drillDownUrl;
			url = overrideDayOfInventoryUrl(url);
			return url;
		};

		$scope.getDefaultDrillDownUrlString = function () {
			var url = $scope.$parent.content.defaultDrillDownUrl;
			url = overrideDayOfInventoryUrl(url);
			return url;
		};

		$scope.saveWidgetSettings = function (doNotReload) {
			$scope.showEditConfig = false;
			widgetContainerScope.hidePencil = false;
			// save config
			var widget = $scope.$parent.model;
			widget.config.settings = _.cloneDeep($scope.settings);
			var newSetting;
			if (widget.config.settings.breakdown) {
				newSetting = widget.config.settings.breakdown;
			} else if (widget.config.settings.doiCalculation) {
				newSetting = widget.config.settings.doiCalculation;
			} else if (widget.config.settings.activeTab) {
				newSetting = widget.config.settings.activeTab;
			} else {
				newSetting = 'UNKNOWN_WIDGET_SETTING';
			}
			pendo.track('widgetChangeConfig', {
				widgetType: widget.config.type,
				mode: newSetting
			});
			var columnDefinition = $scope.$parent.$parent.col;
			if (!$scope.isReadOnly) {
				storeService.dispatch({
					type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
					payload: {
						column: 'column' + columnDefinition.columnIndex,
						position: columnDefinition.widgets.indexOf(widget),
						widget: {
							name: widget.config.type,
							config: _.cloneDeep(widget.config)
						}
					},
					meta: {
						reportName: undefined,
						reportSettingsId: globalReportName
					}
				});
			}

			if (!doNotReload) {
				loadData();
			}
			if ($scope.config.type === 'daysOfInventory') {
				var title = (
					{
						'Forwards': 'Forward',
						'Backwards': 'Backward'
					}[$scope.settings.doiCalculation] +
					' ' + ($scope.settings.doiCalculationTurnsOrDays || 'Days') + ' Of Inventory (' +
					{
						'Purchased Items': 'Purchased',
						'Finished Goods': 'Manufactured'
					}[$scope.settings.doiCalculationItemType] + ')'
				);
				$scope.$parent.$parent.definition.config.title = title;
			}
			// XXX reload table too, if visible
		};
		var services = {
			'currencyFormatService': currencyFormatService,
			'numberFormatService': numberFormatService,
			'integerFormatService': integerFormatService,
			'percentageFormatService': percentageFormatService
		};

		var search = $location.search();

		var fmtService = services[chartProperties[$scope.chartId].fmtService];

		this.checked = true;
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;

		function overrideDayOfInventoryUrl(url) {
			if (!url && $scope.config.type == 'daysOfInventory') {
				var calculationItemType = $scope.settings.doiCalculationItemType || 'Purchased Items';
				var params = chartProperties['daysOfInventory'].drillDownUrls[calculationItemType];
				if (!!params.reactDrilldownExperiment && $experiments.isEnabled(params.reactDrilldownExperiment)) {
					var filters = params.reactDrilldownFilters || [];
					var sorters = params.reactDrilldownSorters || [];
					url = params.reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters);
				} else {
					url = params.drillDownUrl;
				}
			}
			return url;
		}

		function mapIcons() {
			angular.forEach($scope.data.data, function (row) {
				if (row.actionStatus) {
					row.actionStatusIcon = iconMap[row.actionStatus];
					row.actionStatusTip = iconTip[row.actionStatus];
				} else {
					row.actionStatusIcon = 'fa fa-plus task-status-none';
					row.actionStatusTip = 'Click to create task';
				}
			});
		}

		function getSelectedBuyerPlannerList(filterName, undefinedLabel, undefinedLabelValue) {
			var selectedOptionList = [];
			var selected = $scope.filterService.getSelected(filterName);
			for (var i = 0; i < selected.length; i++) {
				if (selected[i] === undefinedLabel) {
					selectedOptionList.push(undefinedLabelValue);
				} else {
					selectedOptionList.push(selected[i]);
				}
			}
			return selectedOptionList;
		}

		function getTable(e) {
			if ($(e.target).parents('.c3-legend-item').length) {
				// ignore legend click events
				return;
			}
			if (chartProperties[type].tableUrl) {
				var qParamObj = {};
				if (typeof chartProperties[type].getTableUrlParams === 'function') {
					_.assign(qParamObj, chartProperties[type].getTableUrlParams($scope, chartProperties[type]));
				}
				var url = addQueryParam(chartProperties[type].tableUrl, $scope.filterService.getSelected('Factory'), qParamObj, false);
				url = $scope.leanFilterService.addFilterQueryParams(url);
				if (!$scope.show_table) {
					$scope.loadingTable = true;
					getJsonData.get(hostUrl + url).then(
						function (d) {
							$scope.data = d;
							if (chartProperties[type].dataFunction) {
								if (type === 'daysOfInventory') {
									if ($scope.settings.doiCalculationItemType === undefined) {
										$scope.settings.doiCalculationItemType = 'Purchased Items';
									}
								}
								chartProperties[type].dataFunction($scope.data.data, $scope.settings);
							}
							if (d && d.data) {
								for (var i = 0; i < d.data.length; i++) {
									var authFact = globalConfig.user.authFacts[d.data[i].ldfNdx];
									if (authFact && authFact.daysDisplayType !== 'Calendar Days') {
										if (d.data[i].leadTime) {
											d.data[i].leadTime = d.data[i].leadTime / 7 * 5;
											d.data[i].leadTimeDaysDisplay = ' Work Days';
										}
									}
								}
							}
							fnToggleTbl1();
							$scope.loadingTable = false;
							mapIcons();
						},
						function (e) {
							$scope.error = e;
							fnToggleTbl1();
							$scope.loadingTable = false;
						}
					);
				} else {
					fnToggleTbl1();
				}
			}
		}

		function fnFmtBigNum() {
			var units = chartProperties[$scope.chartId].addnlBgNumUnits;
			if (typeof units === 'function') {
				$scope.addnlBgNumUnits = units($scope.settings);
			} else {
				$scope.addnlBgNumUnits = units;
			}
			$scope.formattedBgNum = $scope.bgNum;
			if ($scope.settings.breakdown && $scope.settings.breakdown === 'POPlacementsByMonth') {
				$scope.addnlBgNumUnits = 'On Time';
				$scope.formattedBgNum.value = $scope.formattedBgNum.value || 0;
				$scope.formattedBgNum.value = percentageFormatService.getWithParameters(
					$scope.formattedBgNum.value, 0);

			} else if ($scope.chartId === 'daysOfInventory' && units($scope.settings) === 'Turns') {
				var decimals = numberOfDecimals($scope.formattedBgNum.value, 0);
				$scope.formattedBgNum.value = fmtService.getWithParameters(
					$scope.formattedBgNum.value, decimals, $scope.currency);
			} else {
				$scope.formattedBgNum.value = fmtService.getWithParameters(
					$scope.formattedBgNum.value, 0, $scope.currency);
			}

			if (!$scope.formattedBgNum.value) {
				$scope.formattedBgNum.value = 0;
			}

			if ($scope.bgNum && $scope.bgNum.status) {
				$scope.bgNumClass = $scope.bgNum.status;
			}
		}

		function setDrilldownUrl() {
			var skipUseWeeklyLogItem = $scope.isShortages && $scope.settings.breakdown !== 'None';
			$scope.$parent.$parent.showViewReport = true;
			if (eventName === 'event:clearToBuildPercentageCtrl:getChart' ||
				eventName === 'event:clearToCommitPercentageCtrl:getChart') {
				if(leanFilterService.getFactoryList().split(',').length > 1 ||
						(leanFilterService.getFactoryList().split(',').length === 1 && !(clearToBuildV1Enabled || clearToBuildV2Enabled))){
					$scope.$parent.$parent.showViewReport = false;
				}
			}
			if (skipUseWeeklyLogItem) {
				setDrilldownWhenSkipUseWeeklyLogItem();
			} else if ($scope.$parent.content.isNewDrillDown) {
				setDrilldownForIsNewDrilldown();
			} else {
				setDrilldownUrlDefault();
			}
		}

		function setDrilldownWhenSkipUseWeeklyLogItem() {
			var filters = buyerStdCurrentShortagesService.getDrilldownFilters(null, null, null, true);
			if (eventName === 'event:criticalShortagesManufacturedCtrl:getChart') {
				filters['itemType'] = 'Manufactured';
			} else {
				filters['itemType'] = 'Purchased';
			}
			var sorters = $scope.$parent.content.reactDrilldownSorters;
			var mandatoryColumns = $scope.$parent.content.reactDrilldownMandatoryColumns;
			filters = drilldownFunctionsService.getDrilldownParamArray(filters);
			$scope.$parent.content.drillDownUrl = reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters, false, mandatoryColumns);
		}


		function setDrilldownForIsNewDrilldown() {
			var erpOrderPolicyList = [];
			var erpOrderPolicies = [];
			if (chartProperties[type].excludeMinMaxForDrilldown) {
				var selectedList = $scope.filterService.getSelected('ERP Order Policy');
				var onlyLookAtSelected = selectedList && selectedList.length;
				var allErpOrderPolicyList = $scope.filterService.getObjectList('ERP Order Policy') || [];
				allErpOrderPolicyList.forEach(function (erpOrderPolicy) {
					if (erpOrderPolicy.orderPolicy !== 'MinMax' && erpOrderPolicy.orderPolicy !== 'Kanban'
							&& (erpOrderPolicy.selected || !onlyLookAtSelected)) {
						$scope.leanFilterService.escapeCommasForOrderPolicies(erpOrderPolicies, erpOrderPolicy);
					}
				});
				erpOrderPolicyList = erpOrderPolicies;
			} else {
				erpOrderPolicyList = $scope.filterService.getSelected('ERP Order Policy') || [];
			}
			var isPoReport = $scope.$parent.content.isPoReport;
			var reactDrilldownNotPoReport = (!$scope.$parent.content.isPoReport && !$scope.$parent.content.reactDrilldownExperiment);
			var reactDrilldownByExperiment = ($scope.$parent.content.reactDrilldownExperiment && $experiments.isEnabled($scope.$parent.content.reactDrilldownExperiment));
			var notDaysOfInventoryFinishedGoods = !(eventName === 'event:daysOfInventoryCtrl:getChart' && $scope.settings.doiCalculationItemType === 'Finished Goods');
			if (
				(isPoReport || reactDrilldownNotPoReport || reactDrilldownByExperiment)
				&& reactDrilldownUrl
				&& notDaysOfInventoryFinishedGoods
			) {
				if (_.isString(erpOrderPolicyList)) {
					erpOrderPolicyList = erpOrderPolicyList.split(',').map(function(m) {
						return m.replace(/@@##/g, ',');
					});
				}
				var erpFilter = [{ id: 'erpOrderPolicy', values: erpOrderPolicyList }];
				var sorters = $scope.$parent.content.reactDrilldownSorters;
				var filters = getDrilddownFiltersFromChartParams();
				filters = filters.concat(erpFilter);
				if($scope.excludeBlanketOrdersFilter && ($scope.chartId === 'poBehindSchedule' || $scope.chartId === 'poConfirmation' || $scope.chartId === 'poPlacement')){
					filters.push({id: 'isBlanketOrder', values: [false]});
				}
				if($scope.excludeNoImpactSupplyFilter && ($scope.chartId === 'poConfirmation' || $scope.chartId === 'poPlacement')){
					filters.push({id: 'excludeNonQuantitySupply', values: ['Yes']});
					filters.push({id: 'excludeNonValueSupply', values: ['Yes']});
				}
				if(eventName === 'event:clearToBuildPercentageCtrl:getChart' || eventName === 'event:clearToCommitPercentageCtrl:getChart'){
					var lastAnalyticsRun = globalConfig.user.authFacts[factoryListFromFilter[0]].analyticsExecutionDate;
					var cutoffDate = lastAnalyticsRun == null ? new Date() : new Date(lastAnalyticsRun);
					var offset =
						eventName === 'event:clearToBuildPercentageCtrl:getChart'
							? globalConfig.user.authFacts[factoryListFromFilter[0]].settings.ClearToBuildWindowDays
							: globalConfig.user.authFacts[factoryListFromFilter[0]].settings.ClearToCommitWindowDays;
					cutoffDate.setDate(cutoffDate.getDate() + parseInt(offset, 10));
					var orderStartDate = drilldownFunctionsService.makeRangeFilter('orderStartDate', leanFilterService.comparatorsMap.lessThan, cutoffDate);
					filters.push(orderStartDate);
				}
				var mandatoryColumns = $scope.$parent.content.reactDrilldownMandatoryColumns;
				$scope.$parent.content.drillDownUrl = reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters, false, mandatoryColumns);
			} else {
				var filtersObj = $scope.leanFilterService.getQueryParamsObject(true, true);
				filtersObj.erpOrderPolicy = erpOrderPolicyList.toString();
				if ($scope.$parent.content.useFactoryFilter) {
					filtersObj['factory'] = $scope.leanFilterService.getFactoryList();
					filtersObj['businessunit'] = $scope.filterService.getSelected('Business Unit');
				}
				if($scope.excludeBlanketOrdersFilter && ($scope.chartId === 'poBehindSchedule' || $scope.chartId === 'poConfirmation' || $scope.chartId === 'poPlacement')){
					filtersObj['isBlanketOrder'] = false;
				}
				if (chartProperties[type].drilldownQueryParams) {
					_.assign(filtersObj, chartProperties[type].drilldownQueryParams($scope.settings));
				}
				$scope.$parent.content.drillDownUrl = addQueryParam(
					$scope.getDefaultDrillDownUrlString(), null, filtersObj, false);
			}
		}

		function getDrilddownFiltersFromChartParams() {
			var filters = $scope.$parent.content.reactDrilldownFilters;
			switch ($scope.chartId) {
			case 'componentAvailabilityPercent':
				return filters($scope.settings);
			default:
				return (filters || []);
			}
		}

		function setDrilldownUrlDefault() {
			$scope.$parent.content.drillDownUrl = addQueryParam(
				$scope.getDrillDownUrlString(), null,
				_.omit($scope.leanFilterService.getQueryParamsObject(true, true), $scope.$parent.content.ignoreFilters), true);
		}

		function getChartData() {
			var skipUseWeeklyLogItem = $scope.isShortages && $scope.settings.breakdown !== 'None';
			if (skipUseWeeklyLogItem) {
				var isManufactured = eventName === 'event:criticalShortagesManufacturedCtrl:getChart';
				$scope.itemType = isManufactured ? 'Manufactured' : 'Purchased';
			}
			setDrilldownUrl();
			var chartUrl = chartProperties[type].chartUrl;
			var queryParams  = $scope.leanFilterService.getQueryParamsObject(true);
			if ($scope.isShortages) {
				if ($scope.showCriticalityBreakDown) {
					queryParams['breakdown'] = $scope.settings.breakdown === 'None' ? 'criticalityLevel' : $scope.settings.breakdown;
				} else {
					if ($scope.settings.breakdown === 'criticalityLevel') {
						$scope.settings.breakdown = 'None';
					}
					queryParams['breakdown']  = $scope.settings.breakdown;
				}
			}
			var queryParamObject = _.omit(queryParams, $scope.$parent.content.ignoreFilters);
			if (chartProperties[type].placementUrl && $scope.settings.breakdown) {
				$scope.bottomData = $scope.settings.breakdown === 'POPlacementsByMonth';
				chartUrl = chartProperties[type].placementUrl($scope.settings.breakdown);
			}
			if (chartProperties[type].shortageUrl && $scope.settings.breakdown) {
				$scope.bottomData = $scope.settings.breakdown === 'POPlacementsByMonth';
				chartUrl = chartProperties[type].placementUrl($scope.settings.breakdown);
			}

			if (chartProperties[type].useWeeklyLogItem && !skipUseWeeklyLogItem) {
				weeklyLogItemService.loadData().then(function() {
					return weeklyLogItemService.loadVars();
				}).then(function () {
					setVariablesFromServiceResult(weeklyLogItemService.getResultObj(), weeklyLogItemService.getVarsObj());
				}).catch(function() {
					// TODO add error handling at some point
					setVariablesFromServiceResult(weeklyLogItemService.getResultObj(), weeklyLogItemService.getVarsObj());
				});
			} else {
				var url = addQueryParam(chartUrl,
					$scope.leanFilterService.getFactoryList(), queryParamObject, false);
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				getJsonData.get(hostUrl + url).then(
					function (d) {
						weeklyLogItemService.loadVars().then(
							function () {
								setVariablesFromServiceResult(d, weeklyLogItemService.getVarsObj());
							}
						);
					},
					function (e) {
						$scope.empty = true;
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
			}
		}

		function setupCriticalityShortages() {
			shortageCriticalityLevelService.getShortageCriticalityLevelsGroupByLvl($scope.leanFilterService.getFactoryList(), true).then(function (response) {
				var showCriticalityBreakDown = response && Object.values(response).some(function(item) {return item.active === 1;});
				if (showCriticalityBreakDown) {
					$scope.criticalityLvlRanks = response;
					$scope.showCriticalityBreakDown = true;
				} else {
					$scope.showEditConfig = false;
					widgetContainerScope.hidePencil = false;
					$scope.showCriticalityBreakDown = false;
					if ($scope.settings.breakdown === 'criticalityLevel') {
						$scope.settings.breakdown = 'None';
					}
				}

				if (($scope.$parent.model.isNew || $scope.showCriticalityConfig) && $scope.isShortages) {
					$scope.showEditConfig = true;
					widgetContainerScope.hidePencil = true;
					$scope.$parent.model.isNew = false;
					$scope.showCriticalityConfig = false;
					markWidgetCompleted();
					return;
				} else {
					getChartData();
					markWidgetCompleted();
				}
			});
		}

		function markWidgetCompleted() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;

			if (!$scope.slideshowView) {
				dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
			}
		}

		function getChart() {
			getChartData();
		}

		function setVariablesFromServiceResult(resultObj, factoryVariables) {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;

			if ($scope.isShortages && $scope.settings.breakdown !== 'None') {
				if (!resultObj || !resultObj.length) {
					$scope.empty = true;
					return;
				}
				$scope.data = resultObj;
				var total = $scope.data.length && $scope.data[0].shortageCount || 0;
				var lastTotal = $scope.data.length && $scope.data[$scope.data.length - 1].shortageCount || 0;
				$scope.shortageTotal = total;
				$scope.shortageDelta = total - lastTotal;
				$scope.shortageDeltaFormatted = Math.abs(total - lastTotal);
				$scope.delta = {
					delta: $scope.shortageDelta,
					status: $scope.shortageDelta > 0 ? 'bad' : 'good',
					addnlLabelText: 'since last week'
				};
			} else if (!resultObj || !resultObj.data || !resultObj.data.length) {
				$scope.empty = true;
				if (!$scope.slideshowView) {
					pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				return;
			}
			$scope.empty = false;
			$scope.chartData = resultObj.data || $scope.data;
			var chartProps = chartProperties[$scope.chartId];
			if (chartProps.dataFunction) {
				if ($scope.chartId === 'daysOfInventory') {
					if ($scope.settings.doiCalculationItemType === undefined) {
						$scope.settings.doiCalculationItemType = 'Purchased Items';
					}
				}
				chartProps.dataFunction($scope.chartData, $scope.settings);
				// XXX not sure how to make this more general or put it somewhere more specific
				if ($scope.settings.doiCalculation) {
					// initialized to -1 because 0 !== -1 and that means the factory did not provide any info on these variables
					// we should assume there may be data rather than blocking the user from seeing anything in their widget
					var crossSiteVariables = {
						PROCUREMENT_FINISHED_GOODS_PAST_WEEKS_OF_ORDERS: -1,
						PROCUREMENT_FINISHED_GOODS_FUTURE_WEEKS_OF_ORDERS: -1,
						PROCUREMENT_BUCKETS_IN_PERIOD: -1
					};
					for (var k in factoryVariables) {
						var oneFactoryVariables = factoryVariables[k];
						for (var k in oneFactoryVariables) {
							crossSiteVariables[k] = Math.max(crossSiteVariables[k], oneFactoryVariables[k]);
						}
					}
					var title = '';
					if ($scope.showEditConfig) {
						title = 'Days Of Inventory';
					} else {
						title = (
							{
								'Forwards': 'Forward',
								'Backwards': 'Backward'
							}[$scope.settings.doiCalculation] +
							' ' + ($scope.settings.doiCalculationTurnsOrDays || 'Days') + ' Of Inventory (' +
							{
								'Purchased Items': 'Purchased',
								'Finished Goods': 'Manufactured'
							}[$scope.settings.doiCalculationItemType] + ')'
						);
					}
					// should all zeroes or all 9999's be considered no data?
					// if so uncomment the block comment below
					/* if (!$scope.empty) {
						var minMax = $scope.chartData.reduce(function (previous, current) {
							return {
								min: Math.min(previous.min, current),
								max: Math.max(previous.max, current)
							};
						}, {min: Infinity, max: -Infinity});
						if (minMax.min === 9999 && minMax.max === 9999) {
							$scope.empty = true;
						} else if (minMax.min === 0 && minMax.max === 0) {
							$scope.empty = true;
						}
					} */

					$scope.$parent.$parent.definition.config.title = title;
				}
			}
			$scope.currency = resultObj.currency;
			$scope.expandedTitle = substituteUsingJson($scope.expandedTitle, resultObj.extraParams);
			$scope.extraAxes = resultObj.axes;

			$timeout(function() {
				$scope.$broadcast('event:' + type + 'Ctrl:getChart', null);
			});

			// calculate bgNum
			var idx = 0;
			var end = chartProps.bgNumValIdx;
			var fld = chartProps.bgNumKey;
			if (!fld) {
				fld = chartProps.yAxisFieldKey;
				if (typeof fld === 'function') {
					fld = fld($scope.settings);
				}
			}
			if ($scope.settings.breakdown && $scope.settings.breakdown === 'POPlacementsByMonth') {
				fld = 'monthlyOnTimePercent';
			}
			if (!!!fld) {
				fld = 'value';
			}
			if (fld === 'daysOfInventory') {
				fld += $scope.settings.doiCalculation;
			}

			if ($scope.isShortages && $scope.settings.breakdown !== 'None' && resultObj && resultObj.length) {
				$scope.bgNum = {
					value: $scope.shortageTotal || 0
				};
			} else {
				if (typeof end === 'function') {
					idx = end(resultObj.data, $scope.settings.breakdown);
				} else if (!!!end || end === 'beg') {
					idx = 0;
				} else if (end === 'end') {
					idx = resultObj.data.length - 1;
				}

				if (Array.isArray(fld)) {
					$scope.bgNum = {
						value: fld.reduce(function(a, b) {
							return resultObj.data[idx][b] + a;
						}, 0)
					};
				} else {
					$scope.bgNum = {
						value: resultObj.data[idx][fld]
					};
				}
			}

			fnFmtBigNum();
			if (!$scope.slideshowView) {
				pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
			}
		}

		function substituteUsingJson(str, substitutions) {
			var newSubstitutions = {};
			if (substitutions) {
				for (var key in substitutions) {
					if (substitutions.hasOwnProperty(key)) {
						newSubstitutions['%' + key + '%'] = substitutions[key];
					}
				}
			}

			str = str.replace(/%\w+%/g, function (all) {
				return newSubstitutions[all] || all;
			});
			return str;
		}

		$scope.tableUrl = function () {
			// XXX would be better to define these explicitly so references could be searched for instead of having to think to search for "+ '.html"
			return '/application/f/dashboard/widgets/' + $scope.chartId + '.html';
		};

		$scope.gaTableExpand = function () {
			pendo.track('widgetInteraction', {
				widgetType: $scope.config.type,
				dashboardParentName: storeService.getState().reportSettings.baseReportName,
				interaction: 'detailsExpand'
			});
		};
		$scope.toggleTable = function (event) {
			getTable(event);
		};

		$scope.itemBelongsToCurrentFactory = function () {
			return (parseInt(globalConfig.factory.id) === this.row.ldfNdx);
		};

		$scope.getTooltipForItemInDifferentFactory = function () {
			return 'Change to ' + this.row.factoryName + ' to view item.';
		};

		$scope.getEarlyDeliveryValueUrl = function(row) {
			var drilldownSearch = row.itemCode;
			var reactDrilldownSorters= [{ property: 'scorecardDate', direction: 'DESC' }];
			var drilldownFilters = [
				drilldownFunctionsService.makeSelectFilter('factory', [row.ldfNdx]),
				drilldownFunctionsService.makeSelectFilter('deliveryStatus', ['Delivered - Early']),
				drilldownFunctionsService.makeRangeFilter('actualReceiptDate', leanFilterService.comparatorsMap.between, $scope.dateRange.start, $scope.dateRange.end)
			];
			return '/application/f/home.html#/supply-chain/purchase-orders' + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, reactDrilldownSorters, drilldownSearch);
		};

		$scope.getIndirectSpendDrilldownUrl = function(row) {
			// The report supports neither the buyer, planner, item group nor order policy
			// filters the dashboard carries, so this sends only site plus the clicked category.
			var factories = leanFilterService.getFactoryList().split(',');
			if ($scope.useReactDrilldown) {
				var filters = [
					drilldownFunctionsService.makeSelectFilter('factory', factories),
					drilldownFunctionsService.makeSelectFilter('indirectSpendCategory', [row.itemCode])
				];
				return reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, false);
			}
			return addQueryParam($scope.getDefaultDrillDownUrlString(), null, {
				factory: factories,
				indirectSpendCategory: [row.itemCode]
			}, false);
		};

		$scope.$on('updateRows', function(event, args) {
			if ($scope.data && $scope.data.data) {
				_.map(_.filter($scope.data.data, args.identifier), function(row) {
					for (var key in args.newValues) {
						row[key] = args.newValues[key];
					}

					if (row.actionStatus && row.actionStatus === 'Archived') {
						delete row.actionStatus;
						delete row.taskId;
					}
				});
				mapIcons();
			}
		});

		$scope.$on('filterLoadingFinished', setDrilldownUrl);

		function fnToggleTbl1(event) {
			$scope.show_table = !$scope.show_table;
			$scope.collapse = !$scope.collapse;
			$scope.expand = !$scope.expand;
		}

		updateEventBind($scope, ['sideBarUpdate', 'slideshowViewChanged', 'inventoryFilterChanged']);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				if ($scope.isShortages) {
					setupCriticalityShortages();
				} else {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
					getChart();
				}
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();
	}
})();